<template>
    <ContentCard icon="assets/images/illu-dino.svg" theme="darkgreen">
        <template #title>Make your own dinosaur puppet</template>
        <template #description>Puppeteer Jackson shows us how to make a dinosaur puppet at home.
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'us5ev600tDk')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/dinosaur-roar.pdf" target="_blank" icon="file"
                        class="card__btn" orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
